const styles = () => ({
  icon: {
    width: 217,
    height: 300,
  },
});

export default styles;
